import React, { useContext } from 'react';
import Redirect from 'react-router-dom/Redirect';
import Login from './modules/Login';
import Collaborator from './modules/Collaborator';
import Health from './modules/Health';
import Benefits from './modules/Benefits';
import Massive from './modules/Massive';
import Communications from './modules/Communications';
import Register from './modules/Register';
import { AuthContext } from './providers/AuthProvider';

const RootRedirect = () => {
  const { isLoggedIn } = useContext(AuthContext);
  return <Redirect to={isLoggedIn ? '/colaborador/colaborador' : '/login'} />;
};

const routes = [
  {
    path: '/',
    exact: true,
    component: RootRedirect,
    isProtected: false,
  },
  ...Register,
  ...Login,
  ...Collaborator,
  ...Health,
  ...Benefits,
  ...Massive,
  ...Communications,
  {
    path: '/terms-conditions',
    component: () => {
      window.location.href = '/terms-conditions.html';
      return null;
    },
    public: true,
    isProtected: false,
  },
];

export default routes;
